import React, { useEffect, useRef } from 'react';
import { View, LayoutAnimation, UIManager, Platform, Animated } from 'react-native';

import PropTypes from 'prop-types';

import { VFText, VFButton, Icon, AnimatedVFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import Colors from '@vfgroup-oneplatform/foundation/Components/Themes/Colors';
import { usePrevious } from '@vfgroup-oneplatform/foundation/Utils/Hooks';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { getThemeImages } from '../../../Themes';

import Styles from './EverytingIsOkErrorItem.Styles';

const CustomLayoutAnimation = {
  duration: 250,
  create: {
    type: LayoutAnimation.Types.linear,
    property: LayoutAnimation.Properties.opacity,
  },
  update: {
    type: LayoutAnimation.Types.easeInEaseOut,
  },
  delete: {
    duration: 50,
    type: LayoutAnimation.Types.linear,
    property: LayoutAnimation.Properties.opacity,
  },
};
if (Platform.OS === 'android' && UIManager.setLayoutAnimationEnabledExperimental) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}

const EverytingIsOkErrorItem = props => {
  const { title, description, actionTitle, status, type, actionClass, isLastElement } = props;
  const theme = useTheme() || LightThemeColors;
  const Images = getThemeImages(theme.name);
  const prevType = usePrevious(type);
  const initAnimationValue = type === 'primary' ? 1 : 0;
  const transmissionAnimation = useRef(new Animated.Value(initAnimationValue)).current;
  useEffect(() => {
    LayoutAnimation.configureNext(CustomLayoutAnimation);
  }, [status]);

  useEffect(() => {
    if (type !== prevType) {
      Animated.timing(transmissionAnimation, {
        toValue: type === 'primary' ? 1 : 0,
        duration: 500,
        useNativeDriver: false,
      }).start();
    }
  }, [type, prevType]);

  const itemColor = type === 'primary' ? theme.colors.textColor : Colors.white;
  const itemChange = transmissionAnimation.interpolate({
    inputRange: [0, 0.85, 1],
    outputRange: [Colors.white, itemColor, theme.colors.textColor],
  });
  const getIcon = () => {
    switch (status) {
      case 0:
        return Images.TImages.ic_tick_solved[type];
      case 1:
        return Images.ic_WarningNotification_White;
      case 2:
        return Images.ic_sync_white;
    }
  };
  return (
    <View style={Styles.itemContainer(isLastElement)} testID={FrameworkTestKeys.SubItem}>
      <View style={Styles.errorItemTitle} testID={FrameworkTestKeys.EIOErrorItemView}>
        <View style={Styles.iconContainer} testID={FrameworkTestKeys.IconContainer}>
          <Icon
            type="animatedImage"
            name={getIcon()}
            size={20}
            testID={
              status === 1 ? FrameworkTestKeys.EIOWarningIcon : FrameworkTestKeys.EIOCheckIcon
            }
            style={{ tintColor: itemChange }}
          />
        </View>
        <AnimatedVFText
          style={[Styles.errorItemTitleText(status === 1), { color: itemChange }]}
          testKey={FrameworkTestKeys.SubItemText}
          i18nKey={title}
        />
      </View>
      {status === 1 && (
        <View
          style={Styles.errorItemDescription}
          testID={FrameworkTestKeys.EIOErrorItemDescriptionView}
        >
          <VFText
            i18nKey={description}
            type={type}
            style={Styles.errorItemDescriptionText}
            testKey={FrameworkTestKeys.EIOWarningDesc}
          />
          <View
            style={Styles.actionBottomContainer}
            testID={FrameworkTestKeys.EIOErrorItemDescriptionBottomContainer}
          >
            <VFButton
              title={actionTitle}
              style={Styles.actionBottom}
              type={'primaryWhite'}
              textStyle={Styles.actionBottomText}
              onPress={() => {
                props.onActionClick(actionClass);
              }}
              testKey={FrameworkTestKeys.EIOFixButton}
            />
          </View>
        </View>
      )}
    </View>
  );
};

EverytingIsOkErrorItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  actionTitle: PropTypes.string,
  type: PropTypes.string,
  status: PropTypes.number,
  onActionClick: PropTypes.func,
  actionClass: PropTypes.string,
  isLastElement: PropTypes.bool,
};
export default EverytingIsOkErrorItem;
